export default "__VITE_PUBLIC_ASSET__dd96f5c4__"